<template>
<div>
 <div class="project-container">
    <div style="width: 1px; height: 280px"></div>
    <el-col :span="7" :offset="16">
      <el-card class="box-card wrap">
        <div>
          <h3 style="color: white;font-size: 16px">贵州医科大学2027届毕业生秋季校园招聘会</h3>
          <el-button type="primary" class="btn-style" plain round @click="add('yxl')">
            参会报名
          </el-button>
          <div style="width: 100%;height: 2px"></div>
          <div style="width: 100%; height: 10px"></div>
          <p style="font-size: 13px; color: #eee; line-height: 20px">
            提交后请留意您的联系手机，我们审核通过后会向您发送短信
          </p>

          <p style="font-size: 13px; color: #eee;">相关信息</p>
          <p style="font-size: 11px; color: #eee;">
            1、报名时间：2026年10月11日 上午 10:00 截止报名
          </p>
          <p style="font-size: 11px; color: #eee;">
            2、招聘会时间： 2026年10月13日（星期二） 9：00-15：00
                      </p>
                      <p style="font-size: 11px; color: #eee;">
            3、招聘地点：贵州医科大学北京路校区（贵阳市北京路4号）广场
                      </p>
                     
          <p style="font-size: 11px; color: #eee;">
            4、参会对象：1、省内外机关、部队及各企事业单位等；2、贵州医科大学2027届应届毕业生与往届未就业毕业生。
          </p>
          <p style="font-size: 11px; color: #eee;">
            5、招聘会提供的服务项目：1、免费提供用人单位展台一个（包括一张桌子两把椅子）；2、现场开展毕业生就业政策、就业咨询活动；
          </p>
                      <p style="font-size: 11px; color: #eee;">
            6、主办单位：贵州医科大学招生就业处
          </p>

        <el-button @click="checkResultBtn" type="primary" round icon="el-icon-search">报名结果查询</el-button>
        <el-button @click="lookStudentResumeBtn" type="primary" round icon="el-icon-search">查看学生投递简历</el-button>
        <el-link type="info" style="color: white;margin-left: 20px;"
         :underline="false" round icon="el-icon-question" @click="help">使用教程</el-link>
        </div>
      </el-card>
    </el-col>

  </div>
  <el-dialog title="报名结果查询" width="40%" :visible.sync="dialogFormVisible">
          <el-form style="z-index:!9999999" :model="checkResultForm">
            <el-form-item label="组织机构代码" label-width="120px">
              <el-input v-model="checkResultForm.zzjgdm" autofocus="true" placeholder="请输入您的单位组织机构代码进行查询"></el-input>
            </el-form-item>
            <el-form-item v-if="checkResult.dwmc" label="您的单位名称" label-width="120px" >
              <el-input :disabled="true" v-model="checkResult.dwmc"></el-input>
            </el-form-item>
            <el-form-item v-if="checkResult.dwmc" label="单位联系人" label-width="120px" >
              <el-input :disabled="true" v-model="checkResult.lxr"></el-input>
            </el-form-item>
             <el-form-item v-if="checkResult.dwmc" label="报名状态" label-width="120px" >
               <el-button v-if="checkResult.bmzt == '1'" type="warning" round>审核中，请稍后再来查询！</el-button>
               <el-button v-if="checkResult.bmzt == '2'" type="success" round>审核通过，请按时到场参会！</el-button>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="查看学生投递简历" width="40%" :visible.sync="studentResumeDialogFormVisible">
          <el-form style="z-index:!9999999">
            <el-form-item label="组织机构代码" label-width="120px">
              <el-input v-model="studentResumeForm.zzjgdm" @blur="getCompanyData" autofocus="true" placeholder="请先输入您的单位组织机构代码进行查询"></el-input>
            </el-form-item>
            <el-form-item label="单位名称" label-width="120px" >
              <el-input :disabled="true" v-model="studentResumeForm.dwmc"></el-input>
            </el-form-item>
            <el-form-item label="单位联系人" label-width="120px" >
              <el-input :disabled="true" v-model="studentResumeForm.lxr"></el-input>
            </el-form-item>
            <el-form-item label="补全联系电话" label-width="120px" >
              <el-input v-model="studentResumeForm.lxdh"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="studentResumeDialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitStudentResumeForm" :loading="submitQueryBtnLoading">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="学生投递简历列表" width="60%" top="5vh" :visible.sync="studentResumeDialogVisible">
          <el-row v-if="!showCollectionList">
            <el-col :span="3" :offset="1">  <el-link type="primary" :underline="false" @click="changeShowCollectionList(false)">全部列表（{{ studentResumeAllList.length }}人）</el-link></el-col>
            <el-col :span="3"><el-link type="info" :underline="false" @click="changeShowCollectionList(true)">收藏列表（{{ studentResumeCollectList.length }}人）</el-link></el-col>
          </el-row>
          <el-row v-else>
            <el-col :span="3" :offset="1">  <el-link type="info" :underline="false" @click="changeShowCollectionList(false)">全部列表（{{ studentResumeAllList.length }}人）</el-link></el-col>
            <el-col :span="3"><el-link type="primary" :underline="false" @click="changeShowCollectionList(true)">收藏列表（{{ studentResumeCollectList.length }}人）</el-link></el-col>
          </el-row>
          <el-row style="margin-top: 20px;height: 660px;overflow-y: scroll;">
  <el-col :span="5" v-for="(item, index) in studentResumeList" :key="index" :offset="1">
    <el-card :body-style="{ padding: '0px' }">
      <div style="width: 142px;height: 201px;margin: 10px auto;">
        <el-image 
    style="width: 100%;height:100%;"
    :src="item.touxiang" 
    :preview-src-list="[item.touxiang]"
    >
  </el-image>
      </div>
      
      <div style="padding: 14px;font-size: 12px;">
        <div>姓名：{{item.xm}}</div>
        <div>学历：{{item.xl}}</div>
        <div>专业：{{item.zy}}</div>
        <div>电话：{{item.dh}}</div>
        <div>生源所在地：{{item.syszd}}</div>
        <div>投递时间：{{item.jltd_add_time}}</div>
        <div style="margin-top: 10px;">
          <el-button v-if="item.sc_xs=='2'" type="danger" size="mini" class="button" @click="Collection(index)">已收藏</el-button>
          <el-button v-else type="info" size="mini" class="button" @click="Collection(index)">收藏</el-button>
          <el-button type="primary" size="mini" class="button" @click="showPdf(index)">简历</el-button>
        </div>
       
      </div>
    </el-card>
  </el-col>
</el-row>
        </el-dialog>
</div>
  
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'Project',
    data() {
      return {
        token:'',
        dialogFormVisible: false,
        submitQueryBtnLoading:false,
        studentResumeDialogFormVisible:false,
        studentResumeDialogVisible:false,
        showCollectionList:false,
        studentResumeList:[],
        studentResumeAllList:[],
        studentResumeCollectList:[],
        checkResultForm: {
          zzjgdm: '',
          },
        studentResumeForm:{
          zzjgdm: '',
          dwmc:'',
          lxr:'',
          lxdh:''
        },
        checkResult:{
          dwmc:'',
          bmzt:'',
          lxr:''
        },
        allCount:0,
        // studentResumeList:[]
      }
      },
    methods: {
      help(){
        var url ='https://ltxz-web-0g9a4u0gceef5579-1256658379.tcloudbaseapp.com/clantu/%E5%8D%95%E4%BD%8D%E4%BD%BF%E7%94%A8%E7%AE%80%E5%8D%95%E4%BB%8B%E7%BB%8D.pdf';
        window.open(url);
      },
      Collection(index){
        var that = this;
        // this.showCollectionList = e
        var editStatus = that.studentResumeList[index].sc_xs;
        var tdid = that.studentResumeList[index].tdid;
        if(editStatus == '2'){
          // 弹窗提示是否取消收藏
          
          editStatus ='1'

        }else{
          editStatus ='2'
          // 收藏
          // that.token = '098f6bcd4621d373cade4e832627b4f6-1696574441-1667057407';//测试用
         
        }
        axios
              .post(
                'https://ltxzapi.1kawk.com/career_fair_projects/student/changeCollectionStatus',
                {
                  token: that.token,
                tdid: tdid,
                editStatus: editStatus
                }
              )
              .then(function (res) {
               if(res.data.data.status == 'success'){
                  that.studentResumeList[index].sc_xs = editStatus
              
               }else{
                  that.$message.error(res.data.data.msg);
               }
              })
      },
      showPdf(index){
        var that = this
        var tdid = that.studentResumeList[index].tdid;
        var pdf_url = that.studentResumeList[index]['jl_pdf']
        if(that.studentResumeList[index]['jl_status']=='1'){
          // 将jl_status改为2
          axios
              .post(
                'https://ltxzapi.1kawk.com/career_fair_projects/student/changeJlStatus',
                {
                  token: that.token,
                tdid: tdid,
                editStatus: '2'
                }
              )
              .then(function (res) {
              // 
              })
        }
        var url ='https://public-methods.1kawk.com/pdf-preview/index.html?file='+pdf_url;
        url = url.replace("http://","https://");
        window.open(url);
      },
      changeShowCollectionList(e){
        var that = this
        this.showCollectionList = e
        if(e){
          // 处理收藏数据
          var studentResumeCollectList =[]
          for(var i =0;i<that.studentResumeAllList.length;i++){
            if(that.studentResumeAllList[i]['sc_xs'] == '2'){
              studentResumeCollectList.push(that.studentResumeAllList[i])
            }
          }
          this.studentResumeList = studentResumeCollectList
          this.studentResumeCollectList = studentResumeCollectList
        }else{
          this.studentResumeList = this.studentResumeAllList
        }
      },
      getCompanyData(){
        var that = this;
        var zzjgdm = this.studentResumeForm.zzjgdm;
        if(!zzjgdm){
          this.$message.error('请先填写组织机构代码！');
        }
        // 查询数据并返回
        axios
              .post(
                'https://cfp.1kawk.com/lantu_s_php/check_submit.php',
                {
                  zzjgdm: zzjgdm,
                }
              )
              .then(function (res) {
               if(res.data.status == 'success'){
                  that.studentResumeForm.dwmc = res.data.dwmc;
                  that.studentResumeForm.lxr = res.data.lxr;
                  that.studentResumeForm.lxdh = res.data.lxdh;
               }else{
                  that.$message.error(res.data.msg);
               }
              })
      },
      submitStudentResumeForm(){
        var that = this;
        var zzjgdm = this.studentResumeForm.zzjgdm;
        if(!zzjgdm){
          this.$message.error('请先填写组织机构代码！');
          return false
        }
        if(!this.studentResumeForm.lxdh){
          this.$message.error('联系电话不正确！');
          return false
        }
        // 查询数据并返回
        that.submitQueryBtnLoading = true
        axios
              .post(
                'https://ltxzapi.1kawk.com/career_fair_projects/student/comLogin',
                {
                  zzjgdm: zzjgdm,
                  lxdh:that.studentResumeForm.lxdh
                }
              )
              .then(function (res) {
                
               if(res.data.data.status == 'success'){
                  that.token = res.data.data.token
                  // 验证通过，获取投递简历列表
                  // console.log(that.token)
                that.getStudentResumeList()
                
               }else{
                  that.$message.error(res.data.data.msg);
                  
               }
              })
      },
      getStudentResumeList(){
        var that = this;
        // studentResumeList
        axios
              .post(
                'https://ltxzapi.1kawk.com/career_fair_projects/student/getStudentResumeToCompany',
                {
                  token: that.token,
                }
              )
              .then(function (res) {
               if(res.data.data.status == 'success'){
                that.allCount = res.data.data.student_jl_count;
                var jl_data_jbxx = res.data.data.student_data1;
                var jl_data_jlxx = res.data.data.student_data2;
                var jl_data = [];
                for (var y = 0; y < jl_data_jbxx.length; y++) {
                  for (var z = 0; z < jl_data_jlxx.length; z++) {
                    if (jl_data_jbxx[y]['stu_xh'] == jl_data_jlxx[z]['stu_xh']) {
                      jl_data.push({
                        'touxiang': jl_data_jlxx[z]['touxiang'],
                        'jl_pdf': jl_data_jlxx[z]['jl_pdf'],
                        'jl_status': jl_data_jlxx[z]['jl_status'],
                        'xm': jl_data_jbxx[y]['xm'],
                        'xl': jl_data_jbxx[y]['xl'],
                        'zy': jl_data_jbxx[y]['zy'],
                        'dh': jl_data_jbxx[y]['dh'],
                        'syszd': jl_data_jbxx[y]['syszd'],
                        'tdid': jl_data_jbxx[y]['tdid'],
                        'jltd_add_time': jl_data_jlxx[z]['jltd_add_time'],
                        'sc_xs':jl_data_jbxx[y]['sc_xs'],
                      });
                    }
                  }
                }
                that.studentResumeList = jl_data;
                that.studentResumeAllList = jl_data;
                that.studentResumeDialogFormVisible = false
                that.studentResumeDialogVisible = true
                if(jl_data.length<1){
                  that.$notify.info({
                    title: '消息',
                    message: '还没有学生想贵公司提交简历，请稍后再来看看吧'
                  });
               
                }
                // 初始化处理收藏数据
                var studentResumeCollectList =[]
                for(var i =0;i<that.studentResumeAllList.length;i++){
                  if(that.studentResumeAllList[i]['sc_xs'] == '2'){
                    studentResumeCollectList.push(that.studentResumeAllList[i])
                  }
                }
                that.submitQueryBtnLoading = false
                that.studentResumeCollectList = studentResumeCollectList
               }else{
                  that.$message.error(res.data.data.msg);
               }
              })
      },
      submitForm(){
        var that = this;
        var zzjgdm = this.checkResultForm.zzjgdm;
        if(!zzjgdm){
          this.$message.error('请先填写组织机构代码！');
        }
        // 查询数据并返回
        axios
              .post(
                'https://cfp.1kawk.com/lantu_s_php/check_submit.php',
                {
                  zzjgdm: zzjgdm,
                }
              )
              .then(function (res) {
               if(res.data.status == 'success'){
                  that.checkResult.dwmc = res.data.dwmc;
                  that.checkResult.lxr = res.data.lxr;
                  that.checkResult.bmzt = res.data.bmzt;
               }else{
                  that.$message.error(res.data.msg);
               }
              })
      },
      checkResultBtn(){
        this.dialogFormVisible = true;
      },
      lookStudentResumeBtn(){
        this.studentResumeDialogFormVisible = true;
      },
      add(e) {
        if (e == 'yxl'){
          this.$router.push({name:'add',params:{zph_type:3}})
        }else if(e == 'fyxl'){
          this.$router.push({name:'add',params:{zph_type:2}})
        }
      },
      query() {
        this.$router.push('/query')
      },
    },
  }
</script>

<style scoped>
  .project-container {
    width: 100%;
    height: 100vh;
    background: url('../assets/background.png') center center fixed
      no-repeat;
    background-size: cover;
  }
  .wrap {
    background: url('../assets/login_form.png');
    background-size: 100% 100%;
  }
  .btn-style {
    width: 100%;
    height: 50px;
    margin-top: 20px;
    font-weight: bold;
  }
  .el-card {
    border: none;
  }
  .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }


  .image {
    width: 100%;
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/project/index.vue